module.exports.libraryGraphql = [
  {
    name: "RhHeaderHeroButtonsSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: ["title", "text"],
    graphqlName: "Strapi_ComponentRhEnteteHeroBoutons",
    graphqlFragment: `
    {
      id
      title
      text
      showSearchField
      image {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
      buttons {
        color
        style
        taille
        text
        action
        simplePage {
          data {
            attributes {
              route
              site {
                data {
                  attributes {
                    code
                  }
                }
              }
            }
          }
        }
      }
    }
    `,
  },
  {
    name: "BigQuoteSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["author", "quote"],
    graphqlName: "Strapi_ComponentCommunCitation",
    graphqlFragment: `{
      id
      author
      quote
    } `,
  },
  {
    name: "CtxCitation",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: ["id", "toto"],
    graphqlName: "Strapi_ComponentRhCtxCitation",
    graphqlFragment: `{
      id
      toto
    } `,
  },
  {
    name: "CardSwitch",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "firstTabTitle", "mainTitle", "secondTabTitle"],
    graphqlName: "Strapi_ComponentCommunCardSwitchImg",
    graphqlFragment: `{
      id
      firstTabTitle
      mainTitle
      secondTabTitle
      firstTab {
        description
        id
        job
        name
        image {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
      }
      secondTab {
        description
        id
        job
        name
        image {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
      }
    } `,
  },
  {
    name: "VideoPageCardSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["cardText", "cardTitle"],
    graphqlName: "Strapi_ComponentCommunVideoEtCartePage",
    graphqlFragment: `
    {
      id
      label:title
      description
      cardButtonText
      cardText
      cardTitle
      isCardAlignLeft
      typeMediaPage: typeMedia
      linkMedia
      videoPreview {
        data {
          attributes {
            url
            alternativeText
            width
            name
            formats
          }
        }
      }
      page {
        data {
          attributes {
            route
          }
        }
      }
      media {
        data {
          attributes {
            alternativeText
            height
            url
            width
            mime
            formats
          }
        }
      }
    }`,
  },
  {
    name: "VideoPageCardSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["cardText", "cardTitle"],
    graphqlName: "Strapi_ComponentCommunVideoEtCarteArticle",
    graphqlFragment: `
    {
    id
    media {
      data {
        attributes {
          alternativeText
          mime
          height
          url
          width
        }
      }
    }
    article {
      data {
        attributes {
          slug
        }
      }
    }
    label:title
    description
    cardButtonText
    cardText
    cardTitle
    isCardAlignLeft
    linkMedia
    typeMediaArticle: typeMedia
    videoPreview {
      data {
        attributes {
          alternativeText
          name
          width
          url
          formats
        }
      }
    }
  }`,
  },
  {
    name: "RhJobAdSearchFormSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: ["titleSearchAdsHeader", "filterResultTitle"],
    graphqlName: "Strapi_ComponentRhEnteteRechercheAnnonces",
    graphqlFragment: `{
      id
      titleSearchAdsHeader
      showCitySearchField
      showContractTypeSearchField
      showJobSearchField
      filterResultTitle
      cancelFilterMessage
      image {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
    }`,
  },
  {
    name: "RhJobAdResultsSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhResultatsRechercheAnnonces",
    graphqlFragment: `{              
      id              
      TitleTab1              
      TitleTab2              
      TitleTab3              
      Card {                
        CardBouton {                  
          action                  
          color                  
          style                  
          taille                
        }                
        CardDescription                
        CardTitle              
      }            
    }`,
  },
  {
    name: "CtxArticleHeaderSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentBlogEnteteDArticle",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "CtxArticleViewerSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentBlogVisionneuseDArticle",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "ArticleViewerSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: ["contentEditorJs"],
    graphqlName: "Strapi_ComponentCommunVisionneuseDArticle",
    graphqlFragment: `{
      id
      contentEditorJs
    }`,
  },
  {
    name: "RhJobSectorMosaic",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: ["Text", "Titre"],
    graphqlName: "Strapi_ComponentRhRhJobSectorMosaic",
    graphqlFragment: `{
      id
      Text
      Titre
      secteur_activites {
        data {
          attributes {
            Lien
            name
            slug
            mosaicImage {
              data {
                attributes {
                  alternativeText
                  formats
                  height
                  mime
                  size
                  url
                  width
                }
              }
            }
          }
        }
      }
    }`,
  },
  {
    name: "RhJobAdLastBannersSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["bannerTitle"],
    graphqlName: "Strapi_ComponentRhBandeauxDernieresAnnonces",
    graphqlFragment: `{
      id
      bannerCount
      jobAdCountPerBanner
      bannerTitle
      buttonMoreJobOffer {
        text
        simplePage {
          data {
            attributes {
              route
            }
          }
        }
      }
    }`,
  },
  {
    name: "TitleTextButton",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["text", "label"],
    graphqlName: "Strapi_ComponentCommunTitleTextButtonSection",
    graphqlFragment: `{
      id
      buttonCtaLink
      buttonLabel
      text
      label:title
    }`,
  },
  {
    name: "RhCtxAgencyHero",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhEnteteHeroAgence",
    graphqlFragment: `{ id, toto }`,
  },
  {
    name: "RhCtxAgencyPresentation",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhRhCtxAgencyPresentation",
    graphqlFragment: `{ id, toto }`,
  },
  {
    name: "RhCtxAgencyMosaic",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: ["Titre"],
    graphqlName: "Strapi_ComponentRhCtxAgencyMosaic",
    graphqlFragment: `{ id, Titre }`,
  },
  {
    name: "CtxArticlesByTag",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: ["title"],
    graphqlName: "Strapi_ComponentBlogCtxArticlesListe",
    graphqlFragment: `{ 
      id
      nombrePage
      title
  }`,
  },
  {
    name: "ArticleLeftRightSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [
      "title",
      "article.data.attributes.title",
      "article.data.attributes.Description",
    ],
    graphqlName: "Strapi_ComponentBlogArticleGaucheDroite",
    graphqlFragment: `{ 
      id
      isAlignLeft
      label:title
      article {
        data {
          attributes {
            title
            Description
            publishedAt
            tags {
              data {
                attributes {
                  label
                  slug
                  autoRoute
                }
              }
            }
            slug
            image {
              data {
                attributes {
                  alternativeText
                  formats
                  height
                  mime
                  size
                  url
                  width
                }
              }
            }
          }
        }
      }
  }`,
  },
  {
    name: "CtxJobAdHeaderSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhEnteteAnnonce",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "CtxJobAdViewerSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhVisionneuseAnnonce",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "CtxJobSectorPersons",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["PersSectActTitle"],
    graphqlName: "Strapi_ComponentRhPersonnesSecteurActivite",
    graphqlFragment: `{
      id
      BlocNumber
      CardNumber
      PersSectActTitle
      PersSectActUnderTitle
     }`,
  },
  {
    name: "BlogArticlesSelectionBannerSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id"],
    graphqlName: "Strapi_ComponentBlogArticlesSelectionBanner",
    graphqlFragment: `{ 
    id
    cardNumber
    articles {
      data {
        attributes {
          title
          Description
          slug
          autoRoute
          publishedAt
          tags {
            data {
              attributes {
                label
                slug
                autoRoute
              }
            }
          }
          image {
            data {
              attributes {
                alternativeText
                formats
                height
                mime
                size
                url
                width
              }
            }
          }
        }
      }
    }
  }`,
  },
  {
    name: "CtxRhJobSectorTitleVideo",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhRhTitreVideo",
    graphqlFragment: `{
      id
  }`,
  },
  {
    name: "RhTitreVideoSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunTitreVideo",
    graphqlFragment: `{
      id
      baseLine
      label:title
      imageVideo {
        videoExternal
        typeVideo
        image {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
        video {
          data {
            attributes {
              width
              url
              height
              alternativeText
              size
            }
          }
        }
      }
    }`,
  },
  {
    name: "HeroMediaSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunEnteteHeroImage",
    graphqlFragment: `{
      id
      contentContentBuilder
      hasGradient
      heightPreset
      imageVideo {
        videoExternal
        typeVideo
        image {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
        video {
          data {
            attributes {
              width
              url
              height
              alternativeText
              size
            }
          }
        }
      }
    }`,
  },
  {
    name: "HeroHeaderTagsListSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: ["title"],
    graphqlName: "Strapi_ComponentRhEnteteHeroEtiquettes",
    graphqlFragment: `{
      id
      title
      image {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
    }`,
  },
  {
    name: "BlogNewsletterSubscriptionSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: ["id"],
    graphqlName: "Strapi_ComponentBlogInscriptionNewsletter",
    graphqlFragment: `{ 
        id
        newsLetterForm
        newsLetterTitle
        newsLetterUnderTitle
    }`,
  },
  {
    name: "ArticlesByTagSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [
      "label",
      "article.data.attributes.title",
      "article.data.attributes.Description",
    ],
    graphqlName: "Strapi_ComponentBlogArticleDUnTag",
    graphqlFragment: `{ 
      id
      buttonTitre
      label
      nombrePage
      tag {
        data {
          attributes {
            label
            slug
            publishedAt
          }
        }
      }
    }`,
  },
  {
    name: "ArticlesFrontPage",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "label"],
    graphqlName: "Strapi_ComponentBlogArticleFrontPage",
    graphqlFragment: `{
      id
      buttonLabel
      page {
        data {
          attributes {
            route
          }
        }
      }
      label
  }`,
  },
  {
    name: "ArticlesFrontPageLong",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id"],
    graphqlName: "Strapi_ComponentBlogArticleFrontPageLong",
    graphqlFragment: `{
      id
      nombrePage
  }`,
  },
  {
    name: "FrontPageHeaderSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id"],
    graphqlName: "Strapi_ComponentBlogFrontPageHeader",
    graphqlFragment: `{
      id
      isTagHeader
      headerImage {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
  }`,
  },
  {
    name: "TagsListSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "label"],
    graphqlName: "Strapi_ComponentBlogTagsList",
    graphqlFragment: `{
      id
      label
      tags {
        data {
          attributes {
            label
            slug
            autoRoute
          }
        }
      }
  }`,
  },
  {
    name: "ArticlesByCategorySection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "label"],
    graphqlName: "Strapi_ComponentBlogArticleFrontPageParCategorie",
    graphqlFragment: `{
      id
      label
      nombrePage
      buttonLabel
  }`,
  },
  {
    name: "VideoCardArticleList",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["cardText", "cardTitle"],
    graphqlName: "Strapi_ComponentCommunVideoCardArticleList",
    graphqlFragment: `
    {
      id
      videoCardArticles {
        article {
          data {
            attributes {
              Description
              title
              slug
            }
          }
        }
        cardButtonText
        cardText
        cardTitle
        description
        isCardAlignLeft
        linkMedia
        title
        typeMedia
        media {
          data {
            attributes {
              alternativeText
              width
              url
              name
              height
              mime
            }
          }
        }
        videoPreview {
          data {
            attributes {
              alternativeText
              width
              url
              name
            }
          }
        }
      }
  }`,
  },
  {
    name: "MediaLogoSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "title", "description"],
    graphqlName: "Strapi_ComponentCommunLogosMediaGd",
    graphqlFragment: `{
      id
      label:title
      buttonLabel
      description
      logos {
        data {
          attributes {
            alternativeText
            formats
            url
            width
            height
          }
        }
      }
  }`,
  },
  {
    name: "ContentBuilderSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["contentContentBuilder.html"],
    graphqlName: "Strapi_ComponentCommunContentBuilder",
    graphqlFragment: `{
      id
      contentContentBuilder
      color
      sectionClass
      background_image {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
      container_Size
    }`,
  },
  {
    name: "Faq",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "question", "response", "title"],
    graphqlName: "Strapi_ComponentComFaq",
    graphqlFragment: `{
      id
      label:title
      questions_reponses {
        data {
          attributes {
            question
            response
          }
        }
      }
    }`,
  },
  {
    name: "LatestCostumerReview",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: ["id", "label"],
    graphqlName: "Strapi_ComponentComDernierAvisClient",
    graphqlFragment: `{
      id
      label:titre
      avis_client {
        data {
          attributes {
            description
            emploi
            nom
            video {
              data {
                attributes {
                  alternativeText
                  height
                  width
                  url
                  size
                }
              }
            }
          }
        }
      }
    }`,
  },
  {
    name: "ComposantsIterable",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentAUtilsComposantsIterable",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "ComposantsHeaderIterable",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentAUtilsComposantsHeaderIterable",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "CtxProductCategory",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentComCtxProductCategoryDetails",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "ContactFormSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunFormulaireContact",
    graphqlFragment: `{
      id
      leftContentBuilder
      label:title
      subTitle
      legalMention
      buttonText
      confirmationText
    }`,
  },
  {
    name: "RendezVousFormSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunFormulaireRendezVous",
    graphqlFragment: `{
      id
      label:title
      subTitle
      legalMention
      buttonText
      confirmationText
    }`,
  },
  {
    name: "CandidatureFormSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunFormulaireCandidature",
    graphqlFragment: `{
      id
      label:title
      subTitle
      buttonText
      confirmationText
    }`,
  },
  {
    name: "RhGlassdoorReviewSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentRhAvisGlassdoor",
    graphqlFragment: `{
      id
      showLogo
      slideCount
      title
      logo {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
    }`,
  },
  {
    name: "ComTrustpilotReviewSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunAvisTrustpilot",
    graphqlFragment: `{
      id
      logo {
        data {
          attributes {
            alternativeText
            formats
            height
            mime
            size
            url
            width
          }
        }
      }
      showLogo
      slideCount
      title
    }`,
  },
  {
    name: "BlogLastesArticlesSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunDerniersArticles",
    graphqlFragment: `{
      id
      buttonCtaLink
      buttonLabel
      BlogLastesArticlesSectionTitle: title
    }`,
  },
  {
    name: "SearchResultSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunResultatsRecherche",
    graphqlFragment: `{
      id
      label:title
      imageVideo {
        videoExternal
        typeVideo
        image {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
        video {
          data {
            attributes {
              width
              url
              height
              alternativeText
              size
            }
          }
        }
      }
      hasGradient
    }`,
  },
  {
    name: "SearchAgencySection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentSlRechercheAgence",
    graphqlFragment: `{
      id
      label:title
      backgroundImage {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
      buttonText

    }`,
  },
  {
    name: "CtxEnteteAgenceSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentSlCtxEnteteAgence",
    graphqlFragment: `{
      id
      backgroundImage {
          data {
            attributes {
              alternativeText
              formats
              height
              mime
              size
              url
              width
            }
          }
        }
    }`,
  },
  {
    name: "CtxDepartementAgencesSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentSlCtxDepartementAgences",
    // TODO: rename SubTitle=>subTitle
    graphqlFragment: `{
      id
      subTitle:SubTitle
    }`,
  },
  {
    name: "CtxRegionAgencesSection",
    isInMultiPages: true,
    isInSimplePages: false,
    searchFields: [],
    graphqlName: "Strapi_ComponentSlCtxRegionAgences",
    graphqlFragment: `{
      id
      subTitle
    }`,
  },
  {
    name: "ConversionFormSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunFormulaireConversion",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "ConversionFormSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunFormulaireConversion",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "OngletCartesSection",
    isInMultiPages: false,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentCommunOngletCarte",
    graphqlFragment: `{
      id
      allCategoriesLabel
      buttonText
      cardList {
        id
        label
        linkCtaLink
      }
    }`,
  },
  {
    name: "CommuniquesDePresseParAnneeSection",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentGrpCommuniquesDePresseParAnnee",
    graphqlFragment: `{
      id
    }`,
  },
  {
    name: "ArticlesPresseParAnnee",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentGrpArticlesDePresseParAnnee",
    graphqlFragment: `{
      id
    }`,
  },

  {
    name: "LastCommuniquesPressSlider",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentGrpBandeauDerniersCommuniquesDePresse",
    graphqlFragment: `{
      id
      buttonCtaLink
      buttonText
      subTitle
      label:title
      isPdfButton
    }`,
  },

  {
    name: "LastPressArticles",
    isInMultiPages: true,
    isInSimplePages: true,
    searchFields: [],
    graphqlName: "Strapi_ComponentGrpDerniersArticlesDePresse",
    graphqlFragment: `{
        id
        buttonCtaLink
        buttonText
        label:title
    }`,
  },
]
